<template>
  <div :class="[disabled ? 'is_disabled' : 'is_valid']" class="xh-files-cont xh-form-border">
    <flexbox :class="[disabled ? 'is_disabled' : 'is_valid']" class="f-header" @click.native="selectImage">
      <i v-if="!disabled" class="wukong wukong-file f-logo" />

      <div class="f-name">附件</div>
      <!-- <input
        :id="idKey"
        type="file"
        class="bar-iput"
        accept="*.*"
        multiple
        @change="xhUploadFile" > -->
    </flexbox>
    <div class="f-body">
      <flexbox v-for="(item, index) in dataValue" :key="index" class="f-item">
        <i class="wukong wukong-file f-img" />
        <div class="f-name">{{ item | fileName }}</div>
        <div
          v-if="!disabled"
          class="close-button text-red-400 max-md:px-[1.333333vw] md:px-[10px] text-[20px]"
          @click="deleteFile(item, index)"
        >
          ×
        </div>
        <span class="btn md:mr-[10px] max-md:mr-[1.333333vw]" @click="previewClick(item, index)">预览</span>
        <span class="btn" @click="downloadClick(item)">下载</span>
      </flexbox>
    </div>
  </div>
</template>
<script type="text/javascript">
import arrayMixin from './arrayMixin';
import { crmFileDeleteAPI } from '@/api/common';
import { fileSize } from '@/utils/index';
import { downloadFile, getFileIconWithSuffix } from '@/utils';
export default {
  name: 'XhFiles', // 新建 file  以数组的形式上传
  components: {},
  filters: {
    fileName(file) {
      const name = file.name && file.name.length > 10 ? file.name.substring(0, 10) + '...' : file.name;
      return name + '(' + fileSize(file.size) + ')';
    }
  },
  mixins: [arrayMixin],
  props: {
    contractId: {
      type: [String,Number],
      default: ''
    }
  },
  data() {
    return {
      batchId: '' // 批次ID
    };
  },
  computed: {},
  watch: {
    dataValue: {
      handler() {
        if (!this.batchId && this.dataValue && this.dataValue.length) {
          this.batchId = this.dataValue[0].batchId;
        }
      },
      immediate: true
    }
  },
  inject: {
    crmType: { default: '' },
    receivables_id: { default: '' },
    contract_id: { default: '' }
  },
  mounted() {},
  methods: {
    selectImage() {
      if (!this.disabled) {
        this.$wkFile.select().then(ev => {
          this.xhUploadFile(ev);
        });
      }
    },

    /**
     * 图片选择出发
     */
    xhUploadFile(event) {
      var files = event.target.files;
      var firstFile = files[0];
      this.sendFileRequest(firstFile, () => {
        for (let index = 1; index < files.length; index++) {
          const file = files[index];
          this.sendFileRequest(file);
        }
        event.target.value = '';
      });
    },
    // 发送请求
    sendFileRequest(file, result) {
      this.$wkUploadFile
        .upload({
          file: file,
          params: {
            batchId: this.batchId,
            type: 'file'
          }
        })
        .then(({ res }) => {
          const data = res.data || {};
          if (this.batchId == '') {
            this.batchId = data.batchId;
          }
          data.size = fileSize(data.size);
          data.sourceType = 'user';
          this.dataValue.push(data);
          this.$emit('value-change', {
            index: this.index,
            value: this.dataValue
          });
          if (result) {
            result();
          }
        })
        .catch(() => {});
    },
    /** 删除图片 */
    deleteFile(item, index) {
      this.$confirm('您确定要删除该文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let data = {
            id: item.file_id,
            module: '',
            save_name: item.save_name
          };
          if (this.crmType == 'receivables' && this.receivables_id) data.receivables_id = this.receivables_id;
          if (this.contract_id || this.contractId) data.contract_id = this.contract_id || this.contractId;
          // 如果是用户上传的文件, 则不传 合同id, 不删除文件
          if (item.sourceType == 'user') delete data.contract_id;
          // 如果禁止删除远端文件
          if (!item.cantDelRemote) {
            crmFileDeleteAPI(data)
              .then(res => {
                this.dataValue.splice(index, 1);
                this.$emit('value-change', {
                  index: this.index,
                  value: this.dataValue
                });
                this.$message.success('操作成功');
              })
              .catch(() => {});
          } else {
            this.dataValue.splice(index, 1);
            this.$emit('value-change', {
              index: this.index,
              value: this.dataValue
            });
            this.$message.success('操作成功');
          }
        })
        .catch(() => {});
    },
    async downloadClick(file) {
      try {
        await downloadFile({
          path: file.filePath || file.file_path || file.url,
          name: file.name,
          save_name: file.save_name
        });
      } catch (err) {
        console.log(err);
      }
    },
    previewClick(file, fileIndex) {
      this.$bus.emit('preview-image-bus', {
        index: fileIndex,
        data: this.dataValue.map(function(item) {
          return {
            url: item.filePath || item.url || item.file_path,
            name: item.name,
            save_name: item.save_name
          };
        })
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/** 附件  */
.xh-files-cont {
  position: relative;
  display: inline-block;
  border-radius: 3px;
  width: 100%;
  border: 1px solid #ddd;
  padding: 3.5px 5px;
  margin: 3px;
  line-height: 15px;
}

.xh-files-cont.is_disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
  .f-name {
    background-color: #f0f4f8ea;
    color: #c0c4cc;
    cursor: not-allowed;
  }
}

.xh-files-cont.is_valid:hover {
  border-color: #c0c4cc;
}

.f-header {
  cursor: pointer;
  padding: 5px 0 5px;
  .f-logo {
    position: block;
    margin-right: 8px;
    font-size: 12px;
    color: $xr-color-primary;
  }
  .f-name {
    color: #2362fb;
    font-size: 12px;
  }
}
.f-header.is_disabled {
  cursor: not-allowed;
}

.f-body {
  .f-item {
    padding: 3px 0;
    height: 25px;
    .f-img {
      position: block;
      margin-right: 8px;
      font-size: 12px;
      color: $xr-color-primary;
    }
    .f-name {
      color: #666;
      font-size: 12px;
    }
    .close-button {
      cursor: pointer;
    }
    .btn {
      color: #2362fb;
      cursor: pointer;
      flex-shrink: 0;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.bar-iput {
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  opacity: 0;
}
</style>
